import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-picture-dialog',
  templateUrl: './picture-dialog.component.html',
  styleUrls: ['./picture-dialog.component.css']
})
export class PictureDialogComponent implements OnInit {

    url: any;
    dialogHeader: string;
   
    constructor(public dialogRef: MatDialogRef<PictureDialogComponent>) {
    }

    ngOnInit() {

    }

    cancelClick() {
        this.dialogRef.close(false);
    }

    okClick() {
        this.dialogRef.close(true);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/picture-dialog/picture-dialog.component.ts